export default "__VITE_ASSET__DUHSaTEJ__"